import axios from 'axios';

const TransactionApi = {};

const nonce = devsAccountingApi.nonce;

TransactionApi.index = async (params = null) => {
    const url = '/wp-json/devs-accounting/v1/transactions/';
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

TransactionApi.incomes = async (params = null) => {
    const url = '/wp-json/devs-accounting/v1/get-incomes/';
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

TransactionApi.show = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/get-transaction/' + id;
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};
TransactionApi.invoiceDetails = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/get-transaction-invoice/' + id;
    try {
        const response = await axios.get(url, { params: params });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

TransactionApi.delete = async (id, params = null) => {
    const url = '/wp-json/devs-accounting/v1/delete-transaction/' + id;
    try {
        const response = await axios.get(url, {
            headers: {
                'X-WP-Nonce': nonce
            }
        });
        return response.data;
    } catch (error) {
        console.error(error);
        return [];
    }
};

TransactionApi.save = async (data) => {
    let url = "/wp-json/devs-accounting/v1/add-transaction/";
    const res = await axios.post(url, data, {
        headers: {
            'X-WP-Nonce': nonce
        }
    }).then(response => {
        return response.data;
    }).catch(error => { return error.response.data; });
    return res;
}

export default TransactionApi;